/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'list': {
    width: 26,
    height: 23,
    viewBox: '0 0 26 23',
    data: '<path pid="0" d="M10.971 4.092a.908.908 0 010-1.815h13.33a.908.908 0 110 1.815H10.97zm0 8.484a.908.908 0 110-1.815h13.33a.908.908 0 110 1.815H10.97zm0 8.485a.908.908 0 110-1.815h13.33a.908.908 0 110 1.815H10.97zM2.823 3.65L5.23.454a.908.908 0 111.45 1.092L3.666 5.548a.908.908 0 01-1.346.117L.38 3.846a.908.908 0 011.24-1.324l1.203 1.127zM1.62 11.007l1.203 1.127L5.23 8.939a.908.908 0 011.45 1.092l-3.013 4.002a.908.908 0 01-1.346.116L.38 12.331a.907.907 0 111.24-1.324zm1.203 9.612l2.406-3.195a.908.908 0 011.45 1.092l-3.013 4.002a.907.907 0 01-1.346.116L.38 20.816a.907.907 0 111.24-1.324l1.203 1.127z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
